export default __webpack_public_path__ + "static/media/355.c03809f3.jpg";